export default function PlaceholderPage({ title, description }) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <div className="text-5xl mb-4 opacity-20">🚧</div>
        <h2 className="font-heading text-2xl text-vault-navy mb-2">{title}</h2>
        <p className="text-[14px] text-gray-400 max-w-md">{description || 'This feature is coming soon.'}</p>
      </div>
    </div>
  );
}
